<template>
  <div class="py-4 container-fluid">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-lg-12 position-relative z-index-2">
        <div class="row">
          <div class="col-sm-7">
            <h1 class="mainTitle">Dashboard</h1>
            <span class="mainDescription">Hello, Admin</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Stats Cards -->
    <div class="row">
      <div class="col-xl-4 col-sm-6 mb-4" v-for="card in stats" :key="card.title">
        <div class="card shadow border-0" :style="{ backgroundColor: '#A31D1D', color: '#fff' }">
          <div class="card-body text-center py-4">
            <div class="mb-2">
              <i class="material-icons-round" style="font-size: 2rem; color: white">{{ card.icon }}</i>
            </div>
            <h6 class="text-white text-sm mb-1">{{ card.title }}</h6>
            <h4 class="mb-0">{{ card.value }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Links -->
    <div class="row mt-4">
      <div class="col-md-12">
        <h5 class="mb-3">Quick Actions</h5>
        <div class="d-flex gap-3 flex-wrap">
          <router-link to="/products/create" class="btn text-white" style="background-color: #A31D1D">
            <i class="material-icons-round me-1">add</i> New Product
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productService from "@/services/product.service";
import orderService from "@/services/order.service";
import axios from "@/Axios";

export default {
  name: "dashboard-default",
  data() {
    return {
      stats: [
        { title: "Users", value: 0, icon: "people", key: "users" },
        { title: "Orders", value: 0, icon: "receipt_long", key: "orders" },
        { title: "Products", value: 0, icon: "inventory_2", key: "products" },
      ],
    };
  },

  async created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      try {
        // Fetch products count
        const productsData = await productService.getProducts({}, 1, 1);
        const productsCount = productsData.total || 0;

        // Fetch orders count
        const ordersData = await orderService.getOrders();
        const ordersCount = Array.isArray(ordersData) ? ordersData.length : 0;

        // Fetch users count (using /admin/users if exists, or fallback to /dashboard/stats)
        let usersCount = 0;
        try {
          const usersRes = await axios.get("/admin/users");
          const usersData = usersRes.data.data;
          usersCount = Array.isArray(usersData) ? usersData.length : 0;
        } catch (e) {
          console.warn("Could not fetch users directly, checking dashboard stats");
          const statsRes = await axios.get("/dashboard/stats");
          usersCount = statsRes.data.data?.users || statsRes.data.data?.contacts || 0;
        }

        this.stats = [
          { title: "Users", value: usersCount, icon: "people", key: "users" },
          { title: "Orders", value: ordersCount, icon: "receipt_long", key: "orders" },
          { title: "Products", value: productsCount, icon: "inventory_2", key: "products" },
        ];

      } catch (error) {
        console.error("Failed to load dashboard data:", error);
      }
    },
  },
};
</script>

<style scoped>
/* Removed the full page background override */
</style>
